module.exports = __webpack_public_path__ + "static/media/ic-add.51b30c00.svg";